module.exports = __webpack_public_path__ + "media/bootstrap-icons/type-h3-e70f5bf7.svg";